<template>
    <div ref="headerContainer" class="header-container" :style="modeStyle">
        <div
	        class="mobile hidden-lg-and-up"
          :style="{
						'box-shadow': mode === 'dark' ? '0 0 10px 4px rgba(0, 0, 0, 0.1)' : 'none'
          }"
        >
<!--	        <img-->
<!--		        class="logo"-->
<!--		        :src="logo"-->
<!--	        />-->
	        <SvgIcon name="tzmc" class-name="logo" />

            <el-dropdown
	            trigger="click"
	            @command="handleCommand"
	            ref="dropdownRef"
            >
	            <div>
		            <SvgIcon name="fold" class-name="fold-icon" />
	            </div>
<!--                <el-icon-->
<!--	                :size="20"-->
<!--	                :color="mode === 'dark' ? '#333' : '#fff'"-->
<!--                >-->
<!--                    <Fold />-->
<!--                </el-icon>-->
                <template #dropdown>
                    <el-dropdown-menu>
	                    <div
		                    v-for="(item, index) in navbarList"
		                    :key="index"
		                    @click="handleCommand(item.path, 'mobile')"
		                    class="dropdown-menu-item"
	                    >
		                    {{ $tc(item.label) }}
	                    </div>
                    </el-dropdown-menu>
                    <div class="mobile-header-lang-select">
                        <span 
                            class="lang-item" 
                            v-for="lang in langSelector.options"
                            :class="{active:isCurrent(lang)}" 
                            :key="lang.value"
                            @click="switchLang(lang)"
                        >
                            {{ lang.label }}
                        </span>
                    </div>
                </template>
            </el-dropdown>
        </div>
        <div
	        class="pc hidden-md-and-down"
	        :style="{
						'box-shadow': mode === 'dark' ? '0 0 10px 4px rgba(0, 0, 0, 0.1)' : 'none'
	        }"
        >
            <el-row type="flex" justify="center" align="middle">
                <el-col :xs="24" :sm="23" :md="24" :lg="24" :xl="16">
                    <el-row :gutter="10" type="flex" justify="space-between" style="align-items: center;">
                        <!-- LOGO -->
	                    
<!--                        <el-col :span="5" style="display:flex; align-items: center;padding: 0;">-->
<!--	                        <SvgIcon-->
<!--	                          class-name="logo"-->
<!--	                          :name="logo"-->
<!--	                        />-->
<!--                        </el-col>-->
	                    <SvgIcon
		                    class-name="logo"
		                    :name="logo"
	                    />

                        <!-- Menu -->
                        <el-col :span="17">
                            <ul class="nav-menu-container">
	                            <li
	                              v-for="(menu, index) in navbarList"
	                              :key="index"
	                              class="menu-item"
	                              :class="{
																	'menu-item--active': menu.path === currentRouter.path
																}"
	                              @click="handleCommand(menu.path)"
	                            >
		                            <template v-if="!menu.child">
			                            {{ $tc(menu.label) }}
		                            </template>
		                            
		                            <template v-else>
			                            <el-dropdown
				                            @command="handleCommand"
				                            ref="dropdownMenuRef"
			                            >
				                            <span
					                            class="menu-item-dropdown"
					                            :class="{
																				'menu-item-dropdown--active':
																					menu.path === currentRouter.path
					                            }"
					                            style="font-size: 18px;cursor: pointer;"
					                            :style="{
																				color: props.mode === 'light' ? '#fff' : '#333'
					                            }"
				                            >
					                            {{ $tc(menu.label) }}
				                            </span>
				                            <template #dropdown>
					                            <el-dropdown-menu>
						                            <div
							                            v-for="option in menuOptions"
							                            :key="option.value"
							                            @click="handleToView(option)"
							                            class="dropdown-item"
							                            style="padding: 12px 24px;font-size: 18px"
						                            >
							                            {{ $t(option.label) }}
						                            </div>
					                            </el-dropdown-menu>
				                            </template>
			                            </el-dropdown>
		                            </template>
	                            </li>
	                            <li class="menu-item">
		                            <LangSelector
			                            placeholder="选择语言"
			                            :options="langSelector.options"
			                            :style="langSelectorStyle.style"
			                            :label-styles="langSelectorStyle.labelStyles"
			                            v-model="langSelector.current"
			                            :mode="mode"
		                            />
	                            </li>
                            </ul>
                        </el-col>

                        <!-- Lang Select -->
<!--                        <el-col :span="2">-->
<!--                            <LangSelector-->
<!--                                placeholder="选择语言"-->
<!--                                :options="langSelector.options"-->
<!--                                :style="langSelectorStyle.style"-->
<!--                                :label-styles="langSelectorStyle.labelStyles"-->
<!--                                v-model="langSelector.current"-->
<!--                                :mode="mode"-->
<!--                            />-->
<!--                        </el-col>-->
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </div>
    <div v-if="props.placeholder" class="header-placeholder" :style="{ height: headerPlaceholder.height + 'px' }" />
</template>

<script setup>
import {onMounted, onUnmounted, reactive, computed, ref, watchEffect, watch, nextTick} from 'vue'
import { useRouter } from 'vue-router'
import LangSelector from './LangSelector';
import { useI18n } from "vue-i18n";
import { useStore } from "vuex"
import lightLogo from '@/assets/images/index/logo.png'
import darkLogo from '@/assets/images/index/logo1.jpg'


const { locale } = useI18n();
const store = useStore();

const router = useRouter()

const props = defineProps({
    placeholder: {
        type: Boolean,
        default: false
    },
	mode: {
		type: String,
		default: "light"
	}
})

const dropdownRef = ref(null)
const dropdownMenuRef = ref(null)

const headerContainer = ref(null)

const headerPlaceholder = reactive({
    height: 0
})

const langSelector = reactive({
    options: [
        { label: '中文', value: 'zh-CN' },
        { label: 'EN', value: 'en-US' },
        { label: 'DE', value: 'de-DE' },
        { label: 'JP', value: 'jp-JP' },
    ],
    current: null
})

const menuOptions = ref([
	{ label: 'contact.tab.business', value: 1 },
	{ label: 'contact.tab.job', value: 2 }
])

const currentRouter = computed(() => router.currentRoute.value)


const navbarList = computed(() => {
	return [
		{
			label: 'header.Home',
			path: '/'
		},
		{
			label: 'header.TechnicalStrength',
			path: '/manufacture'
		},
		{
			label: 'header.CustomerCase',
			path: '/customer-case'
		},
		{
			label: 'header.Product',
			path: '/productDisplay'
		},
		{
			label: 'header.News',
			path: '/newsInformation'
		},
		{
			label: 'header.Contact',
			path: '/contactus',
			child: true
		},
		{
			label: 'header.moldCloud',
			path: 'https://www.mouldc.com/'
		}
	]
})

const langSelectorStyle = computed(() => {
	return {
		labelStyles: {
			'color': props.mode === 'light' ? '#fff' : '#303133',
			'fontSize': '18px'
		},
		style: {
			'height': '100%',
			'display': 'flex',
			'align-items': 'center'
		},
	}
})

const logo = computed(() => props.mode === 'light' ? 'logo' : 'logo-dark')

const modeStyle = computed(() => {
	const theme = {
		light: {
			backgroundColor: 'transparent',
			color: '#fff'
		},
		
		dark: {
			backgroundColor: '#fff',
			color: '#303133'
		}
	}
	
	return theme[props.mode]
})

function handleToView(option) {
	router.push({
		path: '/contactus',
		query: {
			tab: option.value
		}
	})
	
	nextTick(() => {
		dropdownMenuRef.value?.[0]?.handleClose()
	})
}

function toggleLanguage (lang) {
    locale.value = lang.value;
    store.commit('setLanguage', locale)
}

function debounce(func, delay) {
    let timeoutId;
    return function () {
        const context = this
        const args = arguments
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
            func.apply(context, args)
        }, delay)
    }
}


function handleCommand(path, type){
	if (path === '/contactus' && type !== 'mobile') return
	dropdownRef.value?.handleClose()
  const httpPrefixReg = /https{0,1}:\/\//
  if(httpPrefixReg.test(path)){
      window.open(path)
  }else{
      toPage(path)
  }
}

function toPage(path){
	router.push(path)
}

function isCurrent(value){
    return Object.prototype.toString.call(langSelector.current) === '[object Object]' && langSelector.current.value === value.value
}

function switchLang(value){
	langSelector.current = value
	dropdownRef.value?.handleClose()
}

function initLang(){
    store.dispatch("getLanguage");
    locale.value = store.state.locale;

    const target = langSelector.options.find(item => item.value === locale.value)
    langSelector.current = target
}

function onWindowResize(){
    console.log('xx')
    setTimeout(() => {
        headerPlaceholder.height = headerContainer.value.clientHeight
    }, 50)
}

const onWindowResizeWithDeb = debounce(onWindowResize, 300)

watch(() => langSelector.current,(lang) => {
    if(!lang) return
    toggleLanguage(lang)
})

onMounted(() => {
    initLang()
    onWindowResize()
    window.addEventListener('resize', onWindowResizeWithDeb)
});

onUnmounted(() => {
    window.removeEventListener('resize',onWindowResizeWithDeb)
})

</script>

<style lang="less">
.mobile-header-lang-select {
    padding: 5px 16px;

    .lang-item {
        cursor: pointer;
        &.active {
            color: @primary-color;
        }
        &::after {
            content: '  /  ';
            color: #333;
        }
        &:last-child {
            &::after {
                content: none;
            }
        }
    }
}

.fold-icon {
	width: 32px !important;
	height: 32px !important;
}

.header-container {
    width: 100%;
    //background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;

    .mobile {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        padding: 14px 20px;
        //box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);

        >.logo {
	        width: 105px;
	        height: 32px;
        }
    }

    .pc {
        padding: 16px;
	    //color: #fff;
	    font-size: 18px;
        //box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);

        .logo {
	        width: 222px;
	        height: 32px;
        }

        .nav-menu-container {
            height: 100%;
            list-style: none;
            display: flex;
            justify-content: space-between;
            align-items: center;

            >.menu-item {
                display: inline-block;
                font-size: 18px;
                cursor: pointer;
                transition: color .2s;
	            padding: 20px 0;
	            
	            &--active {
		            font-weight: 700;
	            }
	            
                &:hover {
	                color: @primary-color;
                }
                margin-left: 10px;
            }
	        
	        .menu-item-dropdown:hover {
		        color: @primary-color;
	        }
	        
	        .menu-item-dropdown--active {
		        font-weight: 700;
	        }
        }
    }


}

.dropdown-menu-item {
	padding: 5px 16px;
	white-space: nowrap;
	cursor: pointer;
	
	&:hover {
		background-color: rgba(218, 36, 27, .2);
		color: @primary-color;
	}
}
</style>